module.exports = __webpack_public_path__ + "media/1300_KBSAT30_2022_SERFConclusion.e744c273.mp4";